export enum UserStatusEnum {
  // ACTIVE = "active", INACTIVE = "inactive", INCORRECT = "incorrect", NOT_VERIFIED = "not_verified", SUSPENDED = "suspended"
  ACTIVE = 1, INACTIVE = 2, INCORRECT = 3, NOT_VERIFIED = 4, SUSPENDED = 5

}

export enum UserTabsEnum {
  ACTIVE = 'ACTIVE',
  NOT_VERIFIED = 'NOT_VERIFIED',
  SUSPENDED = 'SUSPENDED',
}

